// MainLayout.js
import React,{useState} from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Navbar from '../LandingComponent/Navbar';
import { removeCookie } from '../../utils/cookieUtils';

const CustomButton = styled(Button)(({ theme, active }) => ({
  margin: theme.spacing(1),
  backgroundColor: active ? 'green' : 'white',
  color: active ? 'white' : 'black',
  '&:hover': {
    backgroundColor: active ? 'darkgreen' : 'lightgray',
  },
}));

function MainLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = location.pathname;
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const handleTabChange = (tab) => {
    navigate(tab); // Navigate to the new tab URL
  };
  const handleLogout = () => {
    setIsAuthenticated(false); 
    removeCookie('userData');
  };
 
  return (
    <Box>
      <Navbar handleLogout={handleLogout}/>
      <Typography variant="h4" gutterBottom sx={{ marginBottom: 5 }}>
        {activeTab === '/user-list' && 'User List'}
        {activeTab === '/user-groups' && 'User Groups'}
        {/* {activeTab === '/board-access' && 'Board Access'} */}
       
      </Typography>

      {activeTab !== '/reports' && (
      <Box sx={{ marginBottom: 2 ,marginLeft:'70px'}}>
        <CustomButton
          active={activeTab === '/user-list'}
          onClick={() => handleTabChange('/user-list')}
        >
          User Access
        </CustomButton>
        <CustomButton
          active={activeTab === '/user-groups'}
          onClick={() => handleTabChange('/user-groups')}
        >
          User Groups
        </CustomButton>
        {/* <CustomButton
          active={activeTab === '/board-access'}
          onClick={() => handleTabChange('/board-access')}
        >
          Board Access
        </CustomButton> */}
       
      </Box>
      )}

      <Outlet /> {/* This is where the page content will be rendered */}
    </Box>
  );
}

export default MainLayout;